import _ from 'lodash';
let postType = 'resource';

const Config = {
  /**
   * postType is the post type, duh.
   */
  postType,


  /**
   * appClass is the className that will be applied to the root component
   */
  appClass: 'resource-grid',


  /**
   * elementId is the id of the element that will contain the app
   */
  elementId: 'resource-grid',


  /**
   * searchPlaceholder is the placeholder text in the text search field
   */
  searchPlaceholder: 'Search Resources',


  /**
   * noResultsText is the text displayed when the filter gets back nothing
   */
  noResultsText: 'No Results Found. Please adjust your search terms.',


  /**
   * pageLength is the number of items per "page"
   */
  pageLength: 9,


  /**
   * apiEndpoint is the url the JSON we’re displaying comes from
   */
  apiEndpoint: `${_.result(window, 'SiteInfo.homeUrl', '')}/wp-json/vtl/${postType}/view`,

  getAPIEndpoint: state => {
    let val = '';
    let queryString = '';
    let queryArray = [
      { key: "posts_per_page", value: Config.pageLength },
      { key: 'paged', value: state.page.page }
    ];

    if(state.filter.text){
      queryArray.push({ key: 's', value: state.filter.text });
    }

    for(const filterKey of Object.keys(state.filter)){
      val = state.filter[filterKey];
      if(!val){
        continue;
      }

      switch(filterKey){
        case 'text':
          break;

        default:
          let filterVals = val.map(f => ({ key: `${filterKey}[]`, value: f.slug }));
          queryArray = queryArray.concat(filterVals);
      }
    }

    queryString = queryArray.map(q => `${encodeURIComponent(q.key)}=${encodeURIComponent(q.value)}`).join('&');
    return Config.apiEndpoint + '?' + queryString;
  }
}


export default Config;



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/config.js